






































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';

import * as GROUPS_QUERY from 'src/graphql/admin/Groups.graphql';
import * as USERS_QUERY from 'src/graphql/admin/Users.graphql';

@Component({
  apollo: {
    users: {
      query: USERS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class GroupMembers extends Vue {
  $refs: {
    newGroupNameRef: HTMLElement
  }

  get groups() {
    let groups = this.$store.state.groups.slice(0);

    groups.unshift({
      id: -1,
      name: '-',
    });

    return groups;
  }

  users = [];

  search = '';
  dialog = false;
  dialogNewGroup = false;
  newGroupName = '';

  editedItem = {
    id: '',
    email: '',
    group: {
      id: '',
      name: '',
    },
    administrator: false,
  };

  headers = [
    { text: 'E-mail',       value: 'email', class: 'fixed-column' },
    { text: 'Group',        value: 'group' },
    { text: 'Role',         value: 'role' },
    { text: 'Last Login',   value: 'last_login' },
  ];

  editedIndex = -1;

  editItem(item) {
    this.editedIndex = this.users.indexOf(item);

    Object.assign(this.editedItem, item);
    this.editedItem.group = this.groups.find( group => group.name == item.group );
    this.editedItem.administrator = item.role === 'Administrator';

    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  save() {
    this.$apollo.mutate({
      mutation: gql`mutation ($userId: String!, $groupId: String!) {
        userSetGroup(userId: $userId, groupId: $groupId)
      }`,
      variables: {
        userId: this.editedItem.id,
        groupId: this.editedItem.group.id,
      },
      update: (store, {data: { userSetGroup }}) => {
        const data = {
          __typename: 'User',
          group: this.editedItem.group.name,
        };

        store.writeFragment({
          id: `User:${this.editedItem.id}`,
          fragment: gql`fragment UserGroup on User {
              group
            }
          `,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        userSetGroup: true
      },
    });

    this.$apollo.mutate({
      mutation: gql`mutation ($userId: String!, $isAdmin: Boolean!) {
        userSetAdmin(userId: $userId, isAdmin: $isAdmin)
      }`,
      variables: {
        userId: this.editedItem.id,
        isAdmin: this.editedItem.administrator,
      },
      update: (store, {data: { userSetGroup }}) => {
        const data = {
          __typename: 'User',
          role: this.editedItem.administrator ? 'Administrator' : 'Customer',
        };

        store.writeFragment({
          id: `User:${this.editedItem.id}`,
          fragment: gql`fragment UserRole on User {
              role
            }
          `,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        userSetAdmin: true
      },
    });

    this.close();
  }

  @Watch('dialog')
  onDialogChange(val) {
    if (!val)
      this.close();
  }

  closeNewGroup() {
    this.dialogNewGroup = false
    this.newGroupName = '';
  }

  saveNewGroup() {
    if (this.newGroupName != '') {
      this.$apollo.mutate({
        mutation: gql`mutation ($name: String!, $description: String!) {
          createGroup(name: $name, description: $description)
        }`,
        variables: {
          name: this.newGroupName,
          description: '',
        },
        refetchQueries: [{ query: GROUPS_QUERY }],
      });

      this.closeNewGroup();
    }
  }

  @Watch('dialogNewGroup')
  onDialogNewGroupChange(val) {
    if (!val) {
      this.closeNewGroup();
    } else {
      setTimeout(() => {
        const input = this.$refs.newGroupNameRef;
        if (input)
          input.focus();
      }, 50);
    }
  }

  sort(items, index, isDescending) {
    const modifier = (isDescending ? -1 : 1);
    return items.sort( (item1, item2) => {
      if (!index)
        return 0;

      const value1 = item1[index];
      const value2 = item2[index];

      if (index === 'last_login') {
        let date1 = new Date(value1);
        let date2 = new Date(value2);

        return modifier * (date1.getTime() - date2.getTime());
      } else {
        if (isFinite(value1) && isFinite(value2))
          return modifier * (value1 - value2);

        return modifier * value1.toString().localeCompare(value2);
      }
    } );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/GroupMembers.vue